var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Material Icon (Same as Info Icon in same component)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.666687 14L8.00002 1.33337L15.3334 14H0.666687ZM8.00002 12C8.18891 12 8.34724 11.9362 8.47502 11.8084C8.6028 11.6806 8.66669 11.5223 8.66669 11.3334C8.66669 11.1445 8.6028 10.9862 8.47502 10.8584C8.34724 10.7306 8.18891 10.6667 8.00002 10.6667C7.81113 10.6667 7.6528 10.7306 7.52502 10.8584C7.39724 10.9862 7.33335 11.1445 7.33335 11.3334C7.33335 11.5223 7.39724 11.6806 7.52502 11.8084C7.6528 11.9362 7.81113 12 8.00002 12ZM7.33335 10H8.66669V6.66671H7.33335V10Z",
    fill: "#D93025"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.148d889d465436a1034b35ce682af1f3.svg";
export { ForwardRef as ReactComponent };